// extracted by mini-css-extract-plugin
export default {"loadinglogin":"LoginForm_loadinglogin__ee6bD","img":"LoginForm_img__wXxLQ"};